import { queryOptions, useQuery } from '@tanstack/react-query'

import { intentionApi } from '../api/intentionApi'
import type { INTENTION_TYPE } from '../models/Intention.enums'

const getPrayersOnIntentionsOptions = ({
  intentionIds,
  intentionTypes,
  enabled,
}: {
  intentionIds?: number[]
  intentionTypes?: INTENTION_TYPE[]
  enabled: boolean
}) =>
  queryOptions({
    queryKey: ['prayers_on_intentions', intentionIds, intentionTypes],
    queryFn: ({ signal }) =>
      intentionApi.getPrayersOnIntentions(
        {
          intentionIds: intentionIds || [],
          intentionTypes: intentionTypes || [],
        },
        { signal },
      ),
    enabled,
  })

export const usePrayersOnIntentionsQuery = ({
  intentionIds,
  intentionTypes,
  enabled,
}: {
  intentionIds?: number[]
  intentionTypes?: INTENTION_TYPE[]
  enabled: boolean
}) => {
  return useQuery(
    getPrayersOnIntentionsOptions({
      intentionIds,
      intentionTypes,
      enabled,
    }),
  )
}
